import {
  createMultiStyleConfigHelpers,
  StyleThemingProps,
} from '@chakra-ui/react'
import { textStyleKeys } from '~/themes/textStyles'
import { useCustomMultiStyleConfig } from '~/utils/chakraUtils'
import { getName } from '~/utils/objectUtils'

import { phoneColorKeys } from './_colors'

const { ContactCardsList: listColors } = phoneColorKeys.Phone

const ContactCardsListParts = [
  'emptySearchResultsBody',
  'emptySearchResultsIcon',
  'emptySearchResultsStatusText',
  'emptySearchResultsText',
  'searchResultsContainer',
  'searchResultsProgress',
  'searchResultsList',
  'emptySearchBody',
  'emptySearchIcon',
  'emptySearchTextContainer',
  'emptySearchText',
  'resultsHeader',
  'resultsHeaderText',
  'resultsHeaderSubText',
  'recentsList',
] as const

const helpers = createMultiStyleConfigHelpers(ContactCardsListParts)
export const ContactCardsList = helpers.defineMultiStyleConfig({
  baseStyle: {
    emptySearchResultsBody: {
      flexDirection: 'column',
      alignItems: 'center',
      height: 'full',
      width: 'full',
      paddingTop: '2.5rem',
      gap: '0.5rem',
    },
    emptySearchResultsIcon: {
      boxSize: '5.625rem',
      color: listColors.EmptySearchResultsIcon.FontColor,
    },
    emptySearchResultsStatusText: {
      color: listColors.EmptySearchResultsStatusText.FontColor,
      textStyle: textStyleKeys.Body1_Bold,
    },
    emptySearchResultsText: {
      color: listColors.EmptySearchResultsText.FontColor,
      textStyle: textStyleKeys.Body2,
    },
    searchResultsContainer: {
      justifyContent: 'center',
      alignItems: 'center',
      height: '2rem',
      paddingTop: '5rem',
    },
    searchResultsProgress: {
      color: listColors.SearchResultsProgress.ProgressColor,
      trackColor: listColors.SearchResultsProgress.TrackColor,
      size: '2rem',
    },
    searchResultsList: {
      display: 'flex',
      width: 'full',
      height: 'full',
    },
    emptySearchBody: {
      width: 'full',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      paddingY: '2.5rem',
      paddingX: '3rem',
      gap: '1.25rem',
    },
    emptySearchIcon: {
      boxSize: '5.625rem',
      color: listColors.EmptySearchIcon.FontColor,
    },
    emptySearchTextContainer: {
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      height: '5.0625rem',
      width: 'full',
    },
    emptySearchText: {
      color: listColors.EmptySearchText.FontColor,
      textStyle: textStyleKeys.H6,
      textAlign: 'center',
    },
    resultsHeader: {
      flexDirection: 'column',
      width: 'full',
      paddingTop: '1.75rem',
      paddingX: '0.75rem',
      paddingBottom: '1rem',
      gap: '0.75rem',
      borderBottom: '1px solid',
      borderColor: listColors.ResultsHeader.BorderColor,
    },
    resultsHeaderText: {
      textStyle: textStyleKeys.Body2_Bold,
    },
    resultsHeaderSubText: {
      textStyle: textStyleKeys.Body1,
      color: listColors.ResultsHeader.Subtext.FontColor,
    },
    recentsList: {
      display: 'flex',
      widht: 'full',
      height: 'full',
    },
  },
})

export const useContactCardsListStyles = (props?: StyleThemingProps) => {
  return useCustomMultiStyleConfig<typeof ContactCardsListParts>(
    getName({ ContactCardsList }),
    props,
  )
}
